import { money, plural } from "./format";

export function bundlePrice(item) {
  const match = String(item.deal || "").match(/\$([0-9.]+)/);
  return match ? Number(match[1]) : item.price;
}

// Every full bundle is billed at the deal price; leftover pieces at the single price.
export function priceForPieces(item, pieces) {
  const n = Math.max(0, Number(pieces) || 0);
  const bundleQty = Number(item.bundleQty) || 0;
  if (!item.deal || !bundleQty) return n * item.price;
  return (
    Math.floor(n / bundleQty) * bundlePrice(item) +
    (n % bundleQty) * item.price
  );
}

export function savingsForPieces(item, pieces) {
  return Math.max(0, item.price * pieces - priceForPieces(item, pieces));
}

// e.g. "5 items · $18.00 · 2 (2 for $30 bundles) + 1 $18.00 each"
export function describePieces(item, pieces) {
  const n = Math.max(0, Number(pieces) || 0);
  let text = `${plural(n, item.saleUnit === "set" ? "set" : "item")} · ${money(priceForPieces(item, n))}`;
  const bundleQty = Number(item.bundleQty) || 0;
  if (item.deal && bundleQty > 0 && n >= bundleQty) {
    const bundles = Math.floor(n / bundleQty);
    const rest = n % bundleQty;
    const parts = [];
    if (bundles) parts.push(`${bundles} (${item.deal} bundle${bundles === 1 ? "" : "s"})`);
    if (rest) parts.push(`${rest} ${money(item.price)} each`);
    text += ` · ${parts.join(" + ")}`;
  }
  return text;
}

export function bundleAppliedText(item) {
  const bundleQty = Number(item.bundleQty) || 0;
  const deal = String(item.deal || "");
  const amount = deal.match(/\$\s*([0-9.]+)/);
  if (!bundleQty) return "Bundle applied";
  return `Bundle applied: ${bundleQty} for ${amount ? `$${amount[1]}` : deal.replace(/^.*?for\s*/i, "")}`;
}
